/* eslint-disable  */
//@ts-nocheck
import { upload } from '@client/components/ajax';
import auth from '@client/components/auth';
import { MediaDropbox } from '@client/components/common/inputs/ImageDropbox';
import { InputLabel } from '@client/components/common/inputs/InputLabel';
import Spinner from '@client/components/Spinner';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

export const CoverImageDropbox = ({
  value,
  onChange,
  influencerId,
}: {
  value: { cdn01; image } | null;
  onChange: (val: { cdn01; image }) => any;
  influencerId: number;
}) => {
  const [state, setState] = useState<'initial' | 'uploading' | 'uploaded'>(
    value ? 'uploaded' : 'initial',
  );

  const [error, setError] = useState<any>(null);

  const handleFileChange = async (file: File) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      if (!event.target?.result) return;

      const img = new Image();

      img.onload = async () => {
        if (img.width !== img.height) {
          setError(`Please use a square image`);
          return;
        }

        try {
          setState('uploading');
          setError(null);

          const { cdn01, image }: any = await upload(file, influencerId);

          onChange({ cdn01, image });
          setState('uploaded');
        } catch (err) {
          console.error(err);
          setError('Something went wrong!');
          setState('initial');
        }
      };

      img.src = event.target.result as string;
    };

    reader.readAsDataURL(file);
  };

  return (
    <div className="h-full flex flex-col">
      <InputLabel label="Cover" />
      <div className="flex items-center justify-center flex-grow border-2 border-dashed border-[#DAE1ED] rounded-[6px]">
        {state === 'initial' ? (
          <MediaDropbox onChange={handleFileChange} />
        ) : null}
        {state === 'uploaded' ? (
          <div className="relative">
            <div className="absolute top-[4px] right-[4px] flex items-center justify-center bg-[#151e34] bg-opacity-50 w-[24px] h-[24px] rounded-full cursor-pointer">
              <FontAwesomeIcon
                icon={faTimes}
                className="leading-none text-white text-sm"
                onClick={() => {
                  onChange(null);
                  setState('initial');
                }}
              />
            </div>
            <img
              className="max-h-[150px] max-w-[150px] rounded-[6px]"
              src={value.cdn01 + value.image}
            />
          </div>
        ) : null}
        {state === 'uploading' ? (
          <div>
            <div className="flex flex-col space-y-4 items-center">
              <Spinner />
              <div className="font-semibold text-[#8F9BB3]">Uploading</div>
            </div>
          </div>
        ) : null}
      </div>
      {error ? (
        <div className="text-red-500 font-semibold mt-2">{error}</div>
      ) : null}
    </div>
  );
};
